import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./SalesChannel.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.SALES),
  name: SitesRouteNames.SITE_SALES_CHANNEL,
  component: Component,
} as RouteRecordRaw;
